import { Badge } from '@components/designSystem/badges/badges'
import { useDesktopNavigation } from '@components/navbar/desktop/DesktopNavigationContext'
import { TasksIcon } from '@components/navbar/icons'
import { useDayLink } from '@hooks/useSelectedDay'
import useTypedTranslation from '@hooks/useTypedTranslation'
import { useTodoCount } from '@state/todoList.ts'
import { routesFactory } from '@utils/routes.ts'

import NavItem from './NavItem'

function TodoListNavItem() {
  const { t } = useTypedTranslation()
  const { storeId, scanId, isActive } = useDesktopNavigation()
  const dayLink = useDayLink()

  const { countOpen } = useTodoCount()

  return (
    <NavItem
      to={dayLink(routesFactory.tasks(storeId, scanId))}
      label={
        <div className='flex items-center gap-2'>
          {t('todoList.title')}
          {countOpen && countOpen > 0 ? <Badge size='sm'>{countOpen}</Badge> : null}
        </div>
      }
      isActive={isActive('out-of-shelf-list')}
      icon={<TasksIcon size={20}/>}
    />
  )
}

export default TodoListNavItem

